var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.324,
    height: 17.856
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.662 17.856a7.527 7.527 0 01-2.99-.6A7.641 7.641 0 01.6 13.185a7.527 7.527 0 01-.6-2.99h1.277a6.358 6.358 0 006.385 6.385 6.358 6.358 0 006.385-6.385 6.25 6.25 0 00-1.809-4.523 5.983 5.983 0 00-4.47-1.862h-.49l1.554 1.554-.873.894-3.128-3.129L7.96 0l.873.873-1.66 1.66h.49a7.527 7.527 0 012.99.6 7.641 7.641 0 014.076 4.076 7.8 7.8 0 010 5.981 7.641 7.641 0 01-4.076 4.076 7.527 7.527 0 01-2.991.59z",
    fill: "#8387a5"
  })));
}

export default SvgRetry;